import React from "react";

export default class SendDialog extends React.Component {

    constructor(props){
        super(props);

        this.state = {
        
        }
    }

    render (){

        return ( 

            <div> 
                <div style={container}>
                    <div style={mainClass}>
                        <h3>{this.props.sent} di {this.props.total} notifiche inviate.</h3>
                    </div>
                </div>
            </div>
        )
    }


}

const mainClass = {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
    border: '1px solid black',
    background: '#ffffff',
    padding: '30px'
}

const container = {
    position: 'fixed',
    width: '100%',
    height: '100%',
    display: 'flex', 
    flexDirection: 'row',
    justifyContent: 'center', 
    alignItems: 'center',
    top: 0,
    left: 0,
    background: '#ffffff88',
    zIndex: 10000, 
}